/**
  name_search:搜索所有的job_title
  job_search:搜索公司和所有的job_title
  data_search:搜索公司和合法的job_title以及合法的城市job_title
  company_search: 搜索所有的公司
**/
export const SEARCH_MODE_TYPE = {
  NAME_SEARCH: 'name_search',
  JOB_SEARCH: 'job_search',
  DATA_SEARCH: 'data_search',
  COMPANY_SEARCH: 'company_search',
};

export const SEARCH_TYPE = {
  JOB_TITLE: 'job_title',
  JOB_TITLE_CITY: 'job_title_city',
  COMPANY: 'company',
};

export const DEFAULT_VIEWPORT = {
  width: 'device-width',
  initialScale: 1,
  maximumScale: 5,
  minimumScale: 1,
  viewportFit: 'auto' as const,
};
